const SectionHeading = ({ heading, text }) => {
  return (
    <div className="border-l-8 border-l-primary flex items-center">
      <div className="ml-3">
        <h3 className="text-xl text-text font-semibold mb-1">{heading}</h3>
        <p className="text-[16px]/[24px] text-disable font-normal">{text}</p>
      </div>
    </div>
  );
};

export default SectionHeading;
